<template>
  <div class="appeal" :style="(currentIndex != 0 && !$isFlag) ? 'background:#fff' : ''">
    <header-item
      :title-array="titleArray"
      :is-show="true"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <!-- 选择申诉 -->
    <div v-if="currentIndex == 0" class="formClass">
      <div class="auth">
        <div class="name" @click="accountClick">
          <img src="~assets/images/accountCenter/1099@2x.png" alt="">
          <div class="text">
            <p>账号找回申诉</p>
            <p>用于绑定手机不使用/账号被骗/忘记账号名等账号信息变更相关问题申诉</p>
          </div>
        </div>
        <div class="name" @click="gameClick">
          <img src="~assets/images/accountCenter/1100@2x.png" alt="">
          <div class="text">
            <p>违规处罚申诉</p>
            <p>针对账号或游戏被处罚有异议的反馈,包含但不限于账号或游戏的封停/禁言以及其他的处罚</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 申诉前须知 -->
    <div v-else-if="currentIndex == 1" class="confirm">
      <p v-show="$isFlag" style="margin-top: 0.52rem;font-size: .34rem;font-weight: bold;padding-left: 0.2rem;border-left: 0.1rem solid #606DE2;">申诉前须知</p>
      <p>
        ●
        请准备一个可以正常收发短信，且能正常通话的手机号码并保持畅通，用于接收申诉处理进度及工作人员必要时与您电话沟通确认账号问题【官方热线
        : 0592-3011618】
      </p>
      <p>
        ●
        账号申述中心，仅限受理雷霆官方通行证账号相关问题，如各渠道账号用户，可自行联系各渠道处理【雷霆部分游戏有下发各渠道联运，渠道方账号，由各渠道方独立管理，可在各渠道版本游戏登录界面，如悬浮按钮等进入查找对应客服联系方式】
      </p>
      <p>
        ●
        温馨提示，雷霆游戏禁止一切非官方形式的私下转让，买卖账号行为，因私下（线下）转让、买卖账号导致的纠纷，请自行与对应买卖双方或者线下平台协商解决！
      </p>
      <!-- <p>● 唯一官方交易平台：www.boyuemobile.com</p> -->
      <div class="bottom">
        <van-checkbox
          v-model="checkedAppeal"
          class="checkbox"
        >我已阅读并同意<span
          style="color: #626fdd"
          @click.stop="ltPassRule"
        >《雷霆通行证服务条款》</span></van-checkbox>
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#616edf"
          class="formClass_btn"
          @click="appealClick"
        >确认申诉</van-button>
        <p @click="speedClick">已申诉过，查看申诉进度</p>
      </div>
    </div>
    <!-- 账号申诉信息 -->
    <div v-else-if="currentIndex == 2">
      <van-form class="appealInfo" @submit="handleSubmit">
        <p class="titleOne" @click="forgetAccount">
          忘记账号？
        </p>
        <van-field
          v-model="appealStepOne.username"
          style="border-radius: 16px 16px  0 0;"
          label="雷霆账号："
          :rules="[{ required: true, message: '不可为空' }]"
        />
        <van-field
          v-model="appealStepOne.phone"
          label="联系手机号："
          :rules="rules.mobileRules"
        />
        <van-field
          v-model="appealStepOne.code"
          label="短信验证码："
          maxlength="6"
          style="border-radius: 0 0 16px 16px;"
          :rules="rules.codeRules"
        >
          <template #button>
            <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode">{{ timeMsg }}</p>
            <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
          </template>
        </van-field>
        <p class="reg_p" style="">*如果一分钟内没有收到验证码请重新获取</p>
        <van-field
          name="radio"
          style="border-radius:16px 16px 0 0 ;"
          label="换绑设置："
          :rules="[{ required: true, message: '不可为空' }]"
          class="radio"
        >
          <template #input>
            <van-radio-group v-model="appealStepOne.needResetPhone" direction="horizontal">
              <van-radio name="1">将联系手机号作为绑定手机</van-radio>
              <van-radio name="0">保留原绑定手机</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="appealStepOne.password"
          label="新密码："
          type="password"
          :rules="rules.passwordRules"
        />  <van-field
          v-model="appealStepOne.passwordSecond"
          label="确认新密码："
          type="password"
          :rules="rules.passwordRules"
        />
        <common-select :selection-info="{selectName:'所玩游戏：',columns:columns,label:'name',val:'game'}" @emitParentVal="emitParentVal" />
        <van-field
          name="radio"
          label="申诉原因："
          class="radio"
          :rules="[{ required: true, message: '不可为空' }]"
          style="border-radius: 0 0 16px 16px ;"
        >
          <template #input>
            <van-radio-group v-model="appealStepOne.appealReason" direction="horizontal">
              <van-radio name="手机号码变更">手机号码变更</van-radio>
              <van-radio name="账号被盗/被骗">账号被盗/被骗</van-radio>
              <van-radio name="其他">其他</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div class="bottom">
          <van-checkbox
            v-model="checked"
            class="checkbox"
          >我已阅读并同意
            <span style="color: #626fdd" @click.stop="ltPassRule">《雷霆通行证服务条款》</span>
            <span style="color: #626fdd" @click.stop="ltUserRule">《雷霆游戏用户隐私政策》</span>
          </van-checkbox>
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#616edf"
            class="formClass_btn"
          >下一步</van-button>
          <!-- <van-button round block type="info" native-type="submit" color="#616edf" class="formClass_btn" @click="currentType = 'login';titleMb=''">返回登录</van-button> -->
        </div>
      </van-form>
    </div>
    <!-- web扫码人脸 -->
    <div v-else-if="currentIndex == 3" class="faceVerify">
      <p>请使用<span style="color: #248af7">个人支付宝</span>，进行扫码验证</p>
      <canvas id="canvas" class="QR" />
      <!-- <p>此二维码有效时间：五分钟</p> -->
      <p style="font-weight: bold">
        请勿将二维码转发给其他人，否则可能造成损失
      </p>
      <van-button
        round
        block
        type="info"
        color="#616edf"
        class="formClass_btn"
        @click="check_face"
      >认证已完成</van-button>
      <p v-if="isShowAppealInfo" style="color: #606de2; margin-bottom: 1rem" @click="handleAppealInfo">手动填写申诉信息</p>
    </div>
    <!-- 查询进度 -->
    <div v-else-if="currentIndex == 4" class="applyspeed">
      <van-field
        v-model="accountAppealNum"
        label="申请单号："
        style="border-radius:16px;"
        :rules="[{ required: true, message: '不可为空' }]"
      />
      <van-button
        round
        block
        type="info"
        color="#616edf"
        class="formClass_btn"
        @click="searchProcess"
      >查询</van-button>
      <div>
        <p v-if="dealToast" class="stepTitle">申诉进度：
          <span>{{ dealToast }}</span>
        </p>
      </div>
      <div v-if="failReason" class="dealReasult">
        <div class="dealFail">
          <p>申诉失败</p>
          <p>尊敬的雷霆用户:
            <br>
            真遗憾，您提交的申诉没有通过审核。<br>
            审核不通过理由：
            <span style="color:red">{{ failReason }}</span><br>
            我们建议您：<br>
            申诉时，尽可能多地提供所记得的信息，每项信息都很重要。<br>
            上传申请人证件请注意：<br>
            1.上传清晰、有效的证件原件扫描件(工作人员会核查该证件真实性及有效日期)；<br>
            2.可用手机、相机、摄像头等进行拍摄，确保正面清晰且完整；<br>
            您可以登录雷霆游戏平台客服系统尝试重新提交申诉。</p>
        </div>
      </div>
    </div>
    <!-- 手动填写信息 -->
    <div v-else-if="currentIndex == 5" class="applyFrom">
      <van-form ref="parentFrom" @submit="appealUserInfoNextStep" @failed="onfailed">
        <van-field
          v-model="appealUserInfo.realName"
          label="姓名："
          class="realNameClass"
          name="realName"
          required
          :rules="[{ required: true, message: '不可为空' }]"
        />
        <van-field
          v-model="appealUserInfo.idCard"
          label="身份证号码："
          class="idCardClass"

          required
          name="idCard"
          :rules="rules.idRules"
        />
        <van-field
          name="uploader"
          required
          label="身份证正面："
          class="uploaderClass"
        >
          <template #input>
            <van-uploader
              v-model="uploaderFront"
              :after-read="afterReadFront"
              :max-count="1"
              class="uploaderFrontClass"
              accept=".jpg,.jpeg,.png,"
              :preview-options="{ closeable: true }"
            >
              <div v-if="uploaderFront.length == 0">
                <div v-if="!$isFlag" class="uploaderDiv">
                  <p>+</p>
                  <p>点击上传</p>
                  <p>
                    请勿上传虚假，模糊不清，生活照，过期证件图片，
                    上传此类图片无法通过申诉
                  </p>
                </div>
                <div v-else class="uploaderDiv">
                  <div class="camera">
                    <img src="~assets/images/accountCenter/233@2x.png" alt="">
                  </div>
                </div>
              </div>
            </van-uploader>
          </template>
        </van-field>
        <van-field
          name="uploader"
          label="身份证反面："
          class="uploaderClass"
          required
        >
          <template #input>
            <van-uploader
              v-model="uploaderBack"
              :after-read="afterReadBack"
              accept=".jpg,.jpeg,.png,"
              :max-count="1"
              :preview-options="{ closeable: true }"
            >
              <div v-if="uploaderBack.length == 0">
                <div v-if="!$isFlag" class="uploaderDiv">
                  <p>+</p>
                  <p>点击上传</p>
                  <p>
                    请勿上传虚假，模糊不清，生活照，过期证件图片，
                    上传此类图片无法通过申诉
                  </p>
                </div>
                <div v-else class="uploaderDiv">
                  <div class="camera">
                    <img src="~assets/images/accountCenter/233@2x.png" alt="">
                  </div>
                </div>
              </div>

            </van-uploader>
          </template>
        </van-field>
        <van-field
          name="uploader"
          label="上传附件："
          :class="$isFlag?'uploaderClass2':'uploaderClass'"
        >
          <template #input>
            <van-uploader
              v-model="uploaderList"
              :max-count="1"
              accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.bmp,.pdf"
              :after-read="afterReadList"
            >
              <div v-if="!$isFlag" class="uploaderDiv">
                <p>+</p>
                <p>点击上传</p>
                <p>请将账号相关凭证信息，例如充值截图上传至附件</p>
              </div>
            </van-uploader>
          </template>
        </van-field>
        <van-field
          v-model="appealUserInfo.situation"
          class="textAreaClass situationClass"
          rows="3"
          autosize
          name="situation"
          type="textarea"
          maxlength="200"
          show-word-limit
          required
          placeholder="请输入您遇到的情况"
          :rules="[{ required: true, message: '不可为空' }]"
          label="遇到情况："
        />
        <van-field
          v-model="appealUserInfo.zoneName"
          maxlength="20"
          label="区组名："
        />
        <van-field
          v-model="appealUserInfo.roleName"
          maxlength="50"
          label="角色名："
        />
        <div class="select">

          <common-area :selection-info="{selectName:'常登录地区：',key:'loginArea'}" @emitAreaVal="emitAreaVal" />
          <common-date :selection-info="{selectName:'注册时间：'}" @emitTimeVal="emitTimeVal" />
          <common-area :selection-info="{selectName:'注册地点：',key:'regArea'}" @emitAreaVal="emitAreaVal" />
        </div>

        <van-field
          v-model="appealUserInfo.usedPwd1"
          label="曾用密码1："
          type="password"
        />
        <van-field
          v-model="appealUserInfo.usedPwd2"
          label="曾用密码2："
          type="password"
        />
        <van-field
          v-model="appealUserInfo.usedPwd3"
          label="曾用密码3："
          type="password"
        />
        <van-field
          v-model="appealUserInfo.roleLevel"
          maxlength="10"
          label="角色等级："
        />
        <van-field
          v-model="appealUserInfo.roleDesc"
          class="textAreaClass"
          rows="3"
          autosize
          type="textarea"
          style="border-radius:0 0 16px 16px "
          maxlength="200"
          show-word-limit
          label="游戏角色描述："
        />

        <div class="bottom">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            plain
            class="formClass_btn"
            @click="currentIndex = 2"
          >上一步</van-button>
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#616edf"
            class="formClass_btn"
          >下一步</van-button>
        </div>
      </van-form>

    </div>
    <!-- 申诉成功提示 -->
    <div v-else-if="currentIndex == 7" class="appealResult">
      <img src="~assets/images/accountCenter/success@2x.png" alt="">
      <p>您的申诉已经提交成功</p>
      <p>申诉单号:{{ appealNumber }}
        <span
          v-clipboard:copy="appealNumber"
          v-clipboard:success="clipboardSuccess"
        >复制</span></p>
      <p>*申诉结果1-3个工作日将以短信的形式发送至申诉信息填写的手机号，请您注意查收。同时您可通过上方申诉单号前往账号申诉结果<span @click="currentIndex = 4">查询申诉进度</span></p>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import { ltCaptcha } from '@/utils/ltCaptcha'
import * as api from '@/api/account-self-manage/accountAppeal'
import sendCode from '@/mixins/sendCode'
import commonSelect from '@/components/commonSelect'
import { throttle } from '@/utils/debounce.js'
import commonArea from '@/components/commonArea'
import commonDate from '@/components/commonDate'
import rules from '@/mixins/validator'

import QRCode from 'qrcode'
export default {
  name: 'Appeal',
  components: {
    headerItem, commonSelect, commonArea, commonDate
  },
  mixins: [sendCode],

  data() {
    return {
      isShowAppealInfo: true,
      showPicker: false,
      username: '',
      uploaderFront: [],
      uploaderBack: [],
      rules: rules,
      checked: false,
      btnText: 15,
      disabledBtn: true,
      appealNumber: '',
      appealUserInfo: {
      },
      currentIndex: 0,
      checkedAppeal: false,
      radio: '1',
      active: 0,
      disabled: false,
      titleMb: '选择申诉类别',
      appealStepOne: {},
      captcha: null,
      uploaderList: [],
      preIndex: [], dealToast: '',
      accountAppealNum: '',
      isV4: false,
      titleArray: ['选择申诉类型 ', '首页', '账号自助管理', '申诉'],
      steplist: [
        {
          name: '找回密码',
          inactiveIcon: '1062',
          activeIcon: '1062',
          finishIcon: '1061'
        },
        {
          name: '换绑手机号',
          inactiveIcon: '1065',
          activeIcon: '1063',
          finishIcon: '1061'
        },
        {
          name: '申诉完成',
          inactiveIcon: '1066',
          activeIcon: '1064',
          finishIcon: '1061'
        }
      ],
      failReason: '',
      columns: [],
      backFlag: true,
      readTimer: null
    }
  },
  watch: {
    currentIndex(newVal, oldVal) {
      console.log(newVal, 'currentIndex', oldVal, '上个index')
      if (this.$isFlag) {
        window.scrollTo(0, 0)
      }
      if (this.backFlag) {
        this.preIndex.push(oldVal)
      }
      let currentTitle = ''
      if (newVal == 0) {
        currentTitle = '选择申诉类别'
      }
      if (newVal == 1) {
        // this.readTimer = setInterval(() => {
        //   this.starReadTime()
        // }, 1000)
        currentTitle = '账号申诉'
        this.$ssd.track('leiting_accountcenter_safeAppeal')
      }
      if (newVal == 2) {
        currentTitle = '申诉账号信息'
      }
      if (newVal == 3) {
        currentTitle = '人脸验证'
      }
      if (newVal == 4) {
        currentTitle = '申诉进度'
      }
      if (newVal == 5) {
        currentTitle = '申诉申请信息'
      }
      if (newVal == 7 || newVal == 8) {
        currentTitle = '提示'
      }
      this.titleArray = [currentTitle, '首页', '账号自助管理', currentTitle]
    }
  },
  created() {
    console.log(this.$route.query)
    if (this.$route.query.stateKey) {
      this.currentIndex = Number(this.$route.query.stateKey) || 0
    }
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.appeal').className = ['appeal accountAppealH5 accountCommonH5']
    } else {
      document.querySelector('.appeal').className = ['appeal accountAppealWeb accountCommonWeb']
    }
    api.game_list().then(res => {
      if (res.status == 0) {
        this.columns = res.data
      }
    })
  },
  beforeDestroy() {
    console.log('ccccccc')
  },
  methods: {
    clipboardSuccess() {
      this.$msg('复制成功', 'success')
    },
    gameClick() {
      this.$ssd.track('leiting_accountcenter_gameAppeal')
      window.open('http://gm.leiting.com/appeal/game')
    },
    forgetAccount() {
      // 忘记账号跳转
      this.$ssd.track('leiting_accountmanage_forgotAccount')
      this.$router.push('/accountCenter/accountSelf/accountRetrieval')
      // window.open('https://helper.leiting.com/account_retrieve/id_card.do')
    },
    searchProcess() {
      if (!this.accountAppealNum) {
        this.$msg('请输入申请单号')
        return
      }
      for (const pair of this.dealFormData({
        accountAppealNum: this.accountAppealNum
      }).entries()) {
        console.log(pair[0] + ', ' + pair[1])
      }
      api.query(this.dealFormData({
        accountAppealNum: this.accountAppealNum
      })).then(res => {
        if (res.status == 0) {
          if (res.data && res.data.result == 'fail') {
            this.failReason = res.data.reason
            this.dealToast = ''
          } else {
            this.failReason = ''
            this.dealToast = res.message
          }
        } else {
          this.dealToast = ''
        }
      })
    },
    ltPassRule() {
      window.open('https://www.leiting.com/common/protocol.html')
    },
    ltUserRule() {
      window.open('https://www.leiting.com/terrace/news/news_detail_ff80808171a5bad00171a64e53870006.html')
    },
    starReadTime() {
      if (this.btnText == 0) {
        this.disabledBtn = false
        clearInterval(this.readTimer)
        this.readTimer = null
        return
      }
      this.btnText--
    },
    check_face() {
      api.check_face().then(res => {
        if (res.status == 0) {
          this.$ssd.track('leiting_appeal_faceOk')
          this.$msg('申诉成功', 'success')
          this.currentIndex = 0
        } else if (res.status == 50002) {
          this.$msg('您好，您的验证结果次数已超过限制，还请您重新扫码进行验证')
          this.getFace()
          this.$ssd.track('leiting_appeal_faceFail')
        }
      })
    },
    getFace() {
      api.get_face().then(res => {
        if (res.status == 0) {
          this.$nextTick(() => {
            this.useqrcode(res.data)
          })
          // }
        } else if (res.status == 50001 || res.status == 50003) {
          // 50001：人脸次数达到上限 50003：强制人脸次数达到上限，不允许人工申诉
          this.disabled = true
          this.$msg(res.message)
        } else {
          this.$msg(res.message)
        }
      })
    },
    dealFormData(data) {
      const fd = new FormData()
      for (const el in data) {
        fd.append(el, data[el])
      }
      return fd
    },
    afterReadFront(file) {
      console.log('aaaaaaaaa', file)
      // this.appealUserInfo.frontOfIdCardPic = [file.file]
      console.log(this.uploaderFront, 'aaaa')
    },
    afterReadBack(file) {
      // this.appealUserInfo.backOfIdCardPic = [file.file]
      console.log(this.uploaderBack, 'bbb')
    },
    afterReadList(file) {
      console.log('aaaaaaaaa', file)
      console.log(this.uploaderList, 'ccccccccc')
    },

    getCode() {
      if (!this.appealStepOne.phone) {
        this.$msg('请输入手机号')
        return
      }
      ltCaptcha((captcha) => {
        api.send_phone_code({
          type: 'ACCOUNT_APPEAL',
          phoneNum: this.appealStepOne.phone,
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.$msg('短信发送成功', 'success')
            this.startTimer()
          }
        })
      })
    },
    useqrcode(url) {
      var canvas = document.getElementById('canvas')
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数
      QRCode.toCanvas(canvas, url, function(error) {
        if (error) {
          console.error(error)
        } else {
          console.log('success!')
        }
      })
    },
    changeActive(type) {
      this.active = type
    },
    navBarClick() {
      this.backFlag = false
      if (this.preIndex.length != 0) {
        this.currentIndex = this.preIndex.pop()
      } else {
        this.$router.go(-1)
      }
    },
    emitParentVal(val) {
      this.appealStepOne.game = val
      console.log(val, this.appealStepOne)
    },
    emitAreaVal(val, key) {
      this.appealUserInfo[key] = val
      console.log(val, key, 'val, key', this.appealUserInfo)
    },
    emitTimeVal(val) {
      this.appealUserInfo.regTime = val
      console.log(val, 'regTime', this.appealUserInfo)
    },
    handleAppealInfo() {
      this.currentIndex = 5
      this.backFlag = true
    },
    scroll(key) {
      const dom = document.querySelector('.' + key + 'Class')
      dom.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    },
    onfailed(errorInfo) {
      console.log(errorInfo)
      this.scroll(errorInfo.errors[0].name)
    },
    appealUserInfoNextStep() {
      const params = { ...this.appealUserInfo }
      if (this.uploaderFront.length == 0 || this.uploaderBack.length == 0) {
        this.scroll('uploaderFront')
        this.$msg('请上传身份证照片')
        return
      }
      params.frontOfIdCardPic = this.uploaderFront[0].file
      params.backOfIdCardPic = this.uploaderBack[0].file
      this.uploaderList[0] && (params.attachment = this.uploaderList[0].file)
      params.realName = this.$aes.cbcEncrypt(params.realName)
      params.idCard = this.$aes.cbcEncrypt(params.idCard)

      for (const pair of this.dealFormData(params).entries()) {
        console.log(pair[0] + ', ' + pair[1])
      }
      api.submit(this.dealFormData(params)).then(res => {
        if (res.status == 0) {
          this.appealNumber = res.data
          this.currentIndex = 7
          this.backFlag = true
        } else {
          if (res.message == '输入的实名信息错误，请重新输入') {
            this.scroll('realName')
          }
        }
      })
    },
    speedClick() {
      this.backFlag = true
      this.currentIndex = 4
      this.$ssd.track('leiting_accountcenter_speedAppeal')
    },
    handleSubmit: throttle(function() {
      this.nextStep()
    }, 500),
    async nextStep() {
      if (!this.checked) {
        this.$msg('请阅读并同意《雷霆通行证服务条款》《雷霆游戏用户隐私协议》', 'warning')
        return
      }
      if (this.appealStepOne.passwordSecond != this.appealStepOne.password) {
        this.$msg('两次输入的密码不一致')
        return
      }
      if (!this.appealStepOne.game) {
        this.$msg('请选择所玩游戏', 'warning')
        return
      }
      const params = { ...this.appealStepOne }
      delete params.passwordSecond
      this.$loading.show()
      const res = await api.check_user(params)
      this.$loading.hide()
      if (res.status != 0) {
        if (res.status === 50004) {
          // 50004:强制人脸,前端隐藏掉PC人工申诉入口
          this.isShowAppealInfo = false
        } else {
          this.isShowAppealInfo = true
          return
        }
      }
      this.$ssd.track('leiting_appeal_nextStep')
      if (res.data) {
        this.$ssd.track('leiting_appeal_isV4')
        if (this.$isFlag) {
          this.currentFaceUrl = res.data
          this.$store.dispatch('accountSelf/saveFaceUrl', res.data)
          console.log(this.$store.state, '.$store')
          if (res.status === 50004) {
            this.$router.push('/accountCenter/accountSelf/faceResult?f=1')
          } else {
            this.$router.push('/accountCenter/accountSelf/faceResult')
          }
        } else {
          this.backFlag = true
          this.currentIndex = 3
          this.$nextTick(() => {
            this.useqrcode(res.data)
          })
        }
      } else {
        this.backFlag = true
        this.currentIndex = 5
      }
    },
    jumpStationUrl(url) {
      window.localStorage.setItem('zfbFlag', '1')
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.style.target = '_blank'
      elink.href = url
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink)
    },
    appealClick() {
      if (this.checkedAppeal) {
        this.backFlag = true
        this.currentIndex = 2
        this.$ssd.track('leiting_accountcenter_sendAppeal')
      } else {
        this.$msg('请阅读并同意《雷霆通行证服务条款》', 'warning')
      }
    },
    accountClick() {
      this.backFlag = true
      this.currentIndex = 1
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';

</style>
<style lang="stylus" scoped>
@import '~assets/css/accountCenter/accountAppeal.styl';
.QR{
  width: 3.65rem !important;
  height: 3.65rem !important;
}
</style>
